export class QuoteHeader {
  associateId: string = null;
  associateIdLease: string = null;
  freeformName: string = null;
  id: number = null;
  lastEightVinNumbers: string = null;
  licenseNumber: string = null;
  openFlag: string = null;
  phoneNumber: string = null;
  rooftopId: number = null;
  statusId: number = null;
  unitNumber: string = null;
  vehicleDescription: string = null;
  vehicleId: number = null;
  vin: string = null;

  constructor(obj?: QuoteHeader) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
